// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__25HPS","paymentContainer":"PaymentPage_paymentContainer__1O-HK"};